/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

enum AppcuesEvent {
  HighlightNotesTab = 'Highlight Notes Tab',
  HighlightPendingEsignOrPromissoryNoteCard = 'Highlight Card with Unsigned ESign Documents Or Promissory Note',
}

export const trackAppcuesEvent = (event: string, eventAttributes?: Record<string, unknown>): void => {
  if (!window.Appcues) {
    return;
  }
  window.Appcues.track(event, eventAttributes);
};

export const appcuesEvents = {
  highlightNotesTab(meta?: Record<string, string>) {
    trackAppcuesEvent(AppcuesEvent.HighlightNotesTab, meta);
  },
  highlightPendingESignOrPromissoryNoteCard(meta?: Record<string, string>) {
    trackAppcuesEvent(AppcuesEvent.HighlightPendingEsignOrPromissoryNoteCard, meta);
  },
};
